import React from "react";
import { useTranslation } from "react-i18next";
import { Loader2 } from "lucide-react";
import {
  AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { cn } from "@/lib/utils";

/** Confirmation before destructive / important actions. */
export const ConfirmDialog = ({ open, onOpenChange, title, description, confirmLabel, destructive = false, loading = false, onConfirm, children, testId = "confirm-dialog" }) => {
  const { t } = useTranslation();
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent className="bg-card" data-testid={testId}>
        <AlertDialogHeader>
          <AlertDialogTitle>{title || t("common.deleteConfirmTitle")}</AlertDialogTitle>
          {description && <AlertDialogDescription>{description}</AlertDialogDescription>}
        </AlertDialogHeader>
        {children}
        <AlertDialogFooter>
          <AlertDialogCancel className="bg-card" data-testid={`${testId}-cancel`}>{t("common.cancel")}</AlertDialogCancel>
          <AlertDialogAction onClick={(e) => { e.preventDefault(); onConfirm?.(); }} disabled={loading} className={cn(destructive && "bg-destructive text-destructive-foreground hover:bg-destructive/90")} data-testid={`${testId}-confirm`}>
            {loading && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}{confirmLabel || t("common.confirm")}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
